<script lang="ts">
import VideoPlayer from "./VideoPlayer.svelte";
import Overlay from "./Overlay.svelte";
import InteractionEventDispatcherElement from "./videoplayer/InteractionEventDispatcherElement.svelte";
import { onMount } from "svelte";


export let maxWidth: string = '100%';
export let maxHeight: string = '100%';
export let noControl: boolean = false;

</script>

<div id="ivdemo-main">

<InteractionEventDispatcherElement />
<VideoPlayer {maxWidth} {maxHeight} {noControl} />
<Overlay />

</div>

<style>
    #ivdemo-main {
        position: fixed;
        width: 100%;
        /* height: 100%; */
    }
</style>
